import { createSelector } from 'reselect';
import roles from '../config/roles';

export const hasRole = (roles) =>
  createSelector(
    (state) => state.Auth.admin,
    (admin) => roles.includes(admin.role),
  );

export const isSuperAdmin = createSelector(
  (state) => state.Auth.admin,
  (admin) => admin.role === roles.SUPER_ADMIN,
);

export const isAdmin = createSelector(
  (state) => state.Auth.admin,
  (admin) => admin.role === roles.ADMIN || admin.role === roles.SUPER_ADMIN,
);

export const isSubscriber = createSelector(
  (state) => state.Auth.admin,
  (admin) => admin.role === roles.SUBSCRIBER,
);

export const isAffiliate = createSelector(
  (state) => state.Auth.admin,
  (admin) => admin.role === roles.AFFILIATE,
);
